<template>
  <div class="black-bg-3" v-if="isEditOpen">
        <div class="white-bg-3">
          <!-- 제목, 기간, 미리보기 -->
            <div class="row onmaum-h-50">
              <div class="col-6"><i class="fas fa-bullhorn text-danger onmaum-font-1vw"></i> 공지사항 <span v-if="!isModify">등록</span><span v-if="isModify">수정</span></div>
              <div class="col-2" v-if="!isModify">
                <!-- <button class="btn btn-onmaum btn-sm ms-auto w-100" @click="previewNotice()">미리보기</button> -->
              </div>
              <div class="col-2"><button class="btn btn-outline-secondary btn-sm ms-auto w-100" @click="cancel()">취소</button></div>
              <div class="col-2" v-if="isModify && (selectedNotice.insert_id != 'isaack0427' || this.$store.state.login.loginID == 'isaack0427')">
                <button class="btn btn-outline-danger btn-sm ms-auto w-100" @click="deleteNotice()">삭제</button>
              </div>
              <div class="col-2">
                <button class="btn btn-success btn-sm ms-auto w-100" @click="insertNotice()" v-if="!isModify">입력</button>
                <button class="btn btn-success btn-sm ms-auto w-100" @click="updateNotice()" v-if="isModify && (selectedNotice.insert_id != 'isaack0427' || this.$store.state.login.loginID == 'isaack0427')">수정</button>
              </div>

              <div class="col-12 mb-1 mt-2">
                <label for="noticeTitle" class="form-control-label">제목</label>
                <input id="noticeTitle" class="form-control invalid" type="text" v-model="noticeTitle" placeholder="제목"/>
              </div>

              <div class="col-md-6 mb-1">
                <label for="noticeStartDate" class="form-control-label">시작일</label>
                <VueDatePicker v-model="noticeStartDate" locale="kr" cancelText="취소" selectText="선택" :format="formatStartDate" placeholder="시작일"></VueDatePicker>
              </div>
              <div class="col-md-6 mb-1">
                <label for="noticeEndDate" class="form-control-label">종료일</label>
                <VueDatePicker v-model="noticeEndDate" locale="kr" cancelText="취소" selectText="선택" :format="formatEndDate" placeholder="종료일"></VueDatePicker>
              </div>
              <div class="col-md-6 mb-1">
                <label class="form-control-label">게시여부</label>
                <div class=text-center>
                  <div class="form-check form-switch d-inline-block">
                    <input class="form-check-input" type="checkbox" role="switch" id="isNoticePublish" v-model="isNoticePublish">
                    <label class="form-check-label" for="isNoticePublish">
                      <span class="badge bg-danger" v-if="!isNoticePublish">미게시</span>
                      <span class="badge bg-primary" v-if="isNoticePublish">게시</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-1 onmaum-dflex onmaum-h-space-around onmaum-v-center">
                <label class="form-control-label">게시형식</label>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="noticeKind" id="noticeKind01" v-model="noticeKind" value="1">
                  <label class="form-check-label" for="noticeKind01">
                    팝업 형식
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="noticeKind" id="noticeKind02" v-model="noticeKind" value="2" disabled>
                  <label class="form-check-label" for="noticeKind02">
                    알림 형식
                  </label>
                </div>
              </div>
              <div class="col-12 text-center">
                <p class="text-onmaum onmaum-font-07vw">공지사항은 게시 형식별 1건만 게시 가능합니다. 현재 게시 중인 공지사항이 있다면 게시 중지되고, 새로운 공지사항이 게시됩니다.</p>
              </div>
            </div>

            <!-- 에디터 영역 -->
            <div id="editor" class="">

            </div>
        </div>
    </div>
</template>

<script>
import { Editor } from '@toast-ui/editor'
import '@toast-ui/editor/dist/toastui-editor.css'
import 'tui-color-picker/dist/tui-color-picker.css';
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css';

import colorSyntax from '@toast-ui/editor-plugin-color-syntax';

let editor = null
export default {
    name: 'NoticeEditor',
    data(){
        return {
            noticeTitle: '',
            noticeStartDate: '',
            noticeEndDate: '',
            isNoticePublish: false,
            noticeKind: '1',
        }
    },
    props:{
        isEditOpen: Boolean,
        isModify: Boolean,
        modifyID: Number,
        selectedNotice: Object,
        toggleEditor: Function,
        editMode: Number,
    },
    methods: {
        //공지사항 저장
        insertNotice(){
          if(!this.noticeTitle || !editor.getMarkdown() || !this.noticeStartDate || !this.noticeEndDate){
            this.$store.commit('setAlert', {
                                            'alertStatus': 'notice'
                                            ,'alertTitle': '공지사항 관리'
                                            ,'alertContent': `모든 입력값은 필수입니다.`
                                          });
            return;
          }

          // console.log(`title: ${this.noticeTitle}
          //             ,content: ${editor.getMarkdown()}
          //             ,isPublish: ${this.isNoticePublish}
          //             ,kind: ${this.noticeKind}
          //             ,start_dt: ${this.noticeStartDate}
          //             ,end_dt: ${this.noticeEndDate}
          //             ,insert_dt: ${new Date().toLocaleString()}
          //             ,insert_id: ${this.$store.state.login.loginID}`)


          this.$store.dispatch('insertNotice', {
                                                  title: this.noticeTitle
                                                  ,content: editor.getMarkdown()
                                                  ,isPublish: this.isNoticePublish
                                                  ,kind: this.noticeKind
                                                  ,start_dt: this.noticeStartDate
                                                  ,end_dt: this.noticeEndDate
                                                  ,insert_dt: new Date().toLocaleString()
                                                  ,insert_id: this.$store.state.login.loginID
                                                  ,insert_name: this.$store.state.login.userName
                                              });
          this.cancel();
        },

        //공지사항 수정
        updateNotice(){
          if(!this.noticeTitle || !editor.getMarkdown() || !this.noticeStartDate || !this.noticeEndDate){
            this.$store.commit('setAlert', {
                                            'alertStatus': 'notice'
                                            ,'alertTitle': '공지사항 관리'
                                            ,'alertContent': `모든 입력값은 필수입니다.`
                                          });
            return;
          }

          // console.log(`id: ${this.modifyID}
          //             ,title: ${this.noticeTitle}
          //             ,content: ${editor.getMarkdown()}
          //             ,isPublish: ${this.isNoticePublish}
          //             ,kind: ${this.noticeKind}
          //             ,start_dt: ${this.noticeStartDate}
          //             ,end_dt: ${this.noticeEndDate}
          //             ,update_dt: ${new Date().toLocaleString()}
          //             ,update_id: ${this.$store.state.login.loginID}`)


          this.$store.dispatch('updateNotice', {
                                                  id: this.modifyID
                                                  ,title: this.noticeTitle
                                                  ,content: editor.getMarkdown()
                                                  ,isPublish: this.isNoticePublish
                                                  ,kind: this.noticeKind
                                                  ,start_dt: this.noticeStartDate
                                                  ,end_dt: this.noticeEndDate
                                                  ,update_dt: new Date().toLocaleString()
                                                  ,update_id: this.$store.state.login.loginID
                                                  ,update_name: this.$store.state.login.userName
                                              });
          this.cancel();
        },

        //공지사항 삭제
        deleteNotice(){
          this.$store.commit('setAlert', {
                                          'alertStatus': 'confirm'
                                          ,'alertTitle': '공지사항 관리'
                                          ,'alertContent': `선택한 공지사항 정보를 삭제하시겠습니까?|1.제목: ${this.noticeTitle}| |**삭제한 정보는 복구할 수 없으므로 신중히 삭제하시기 바랍니다.}`
                                          ,'callback': 'deleteNotice'
                                          ,'parameter': {id: this.modifyID}
                                      }
                          );
          this.cancel();
        },

        // changeEditor(){
        //     this.noticeContent = this.editor?this.editor.getMarkdown():'';
        // },

        //미리보기
        previewNotice(){
            return false;
        },

        //취소
        cancel(){
            this.toggleEditor();
        },

        //게시 시작일 포맷
        formatStartDate(){
            const date = this.noticeStartDate?new Date(this.noticeStartDate):new Date();
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            const hour = date.getHours();
            const minute = date.getMinutes();

            return `${year}/${month}/${day} ${hour}:${minute}`;
        },

        //게시 종료일 포맷
        formatEndDate(){
            const date = this.noticeEndDate?new Date(this.noticeEndDate):new Date();
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            const hour = date.getHours();
            const minute = date.getMinutes();

            return `${year}/${month}/${day} ${hour}:${minute}`;
        },
    },
    mounted(){
        editor = new Editor({
                    el: document.getElementById('editor'),
                    height: '50%',
                    initialEditType: 'wysiwyg',
                    usageStatistics: false,
                    plugins: [colorSyntax],
                    hooks: {
                      addImageBlobHook: async (blob, callback) => {
                        console.log('=========== 이미지 업로드 ==============');
                        await this.$store.dispatch('uploadNoticeImage', {blob: blob});
                        let imageUrl = this.$store.state.common.uploadImageUrl;
                        callback(imageUrl, 'ImageTest');
                        return false; // 기본 이미지 업로드 처리 방지
                      }
                    }
        });

        this.isModify?editor.setMarkdown(`${this.selectedNotice.content}`):editor.setMarkdown('');
        this.noticeTitle = this.isModify?this.selectedNotice.title:'';
        this.noticeStartDate = this.isModify?this.selectedNotice.start_dt:'';
        this.noticeEndDate = this.isModify?this.selectedNotice.end_dt:'';
        this.isNoticePublish = this.isModify?this.selectedNotice.isPublish:false;
        this.noticeKind = this.isModify?this.selectedNotice.kind:'1';

        /*
        console.log(`
        this.isModify: ${this.isModify}
        this.selectedNotice.content: ${this.selectedNotice.content}
        this.selectedNotice.title: ${this.selectedNotice.title}
        this.selectedNotice.start_dt: ${this.selectedNotice.start_dt}
        new Date(this.selectedNotice.end_dt): ${this.selectedNotice.end_dt}
        this.selectedNotice.isPublish: ${this.selectedNotice.isPublish}
        this.selectedNotice.kind: ${this.selectedNotice.kind}
        this.editor: ${editor}
        this.noticeTitle: ${this.noticeTitle}
        this.noticeStartDate: ${this.noticeStartDate}
        this.noticeEndDate: ${this.noticeEndDate}
        this.isNoticePublish: ${this.isNoticePublish}
        this.noticeKind: ${this.noticeKind}
        `);
        */
    }
}
</script>

<style>
.black-bg-3 {
    width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    padding: 20px;
    z-index: 9999;

    justify-content: center;
    align-items: center;
    display: flex;
}
  
.white-bg-3 {
    background: white;
    width: 75%;
    height: 90%;
    min-height: 50%;
    position: relative;
    margin: auto;
    padding: 20px;
    border-radius: 8px;
}
</style>